import './styles.scss'
import LayoutContainer from 'Components/LayoutComponent'
import { TabPanel, TabView } from 'primereact/tabview'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Loader from 'Components/Loader'
import EditApprovedGlobalCoffeePrice from './EditApprovedGlobalCoffeePrices'

function EditApprovedGlobalData() {
  const { t } = useTranslation()

  return (
    <LayoutContainer title={t('EDIT_APPROVED_GLOBAL_DATA')} breadCrumbsTitle={'editApprovedGlobalData'}>
      <TabView className="edit-approved-data-tab-container">
        <TabPanel className="approval-global-tab-view" header={t('GLOBAL_COFFEE_PRICE')}>
          <EditApprovedGlobalCoffeePrice />
        </TabPanel>
        <TabPanel header={t('GLOBAL_DIFFERENTIAL')}>
          <div>This tab is for Global Differentials</div>
        </TabPanel>
      </TabView>
    </LayoutContainer>
  )
}

export default Loader(EditApprovedGlobalData)
